import script from "./AboutMe.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMe.vue?vue&type=script&setup=true&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=545c4ea6&lang=css"

const __exports__ = script;

export default __exports__